import {
  getVersionNumber
} from '../api/index.js'
import {
  message
} from '@/utils/message'

// 获取当前时间yy mm dd hh mf ss
const getGurrentTime = () => {
  let yy = new Date().getFullYear();
  let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
  let dd = (new Date().getDate()) < 10 ? '0' + (new Date().getDate()) : (new Date().getDate());
  let hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
  let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
  let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
  return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
}

// 获取当前时间yy mm dd
const getGurrentTimeNothmf = () => {
  let yy = new Date().getFullYear();
  let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
  let dd = (new Date().getDate()) < 10 ? '0' + (new Date().getDate()) : (new Date().getDate());
  let hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
  let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
  let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
  return yy + '-' + mm + '-' + dd;
}

//转换时间
//获得年月日时分秒
//传入日期//例：2020-10-27T14:36:23
const timeFormatSeconds = function(time) {
  var d = time ? new Date(time) : new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate();
  var hours = d.getHours();
  var min = d.getMinutes();
  var seconds = d.getSeconds();

  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;
  if (hours < 0) hours = '0' + hours;
  if (min < 10) min = '0' + min;
  if (seconds < 10) seconds = '0' + seconds;

  return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
}

//非空判断
const checkEmpty = (str) => {
  if (str == "" || str == undefined || str == null || str.length == 0) {
    return true
  }
  return false
}

//随机4位字符串
const generateRandomString = () => {
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let randomString = '';
  for (let i = 0; i < 4; i++) {
    // 随机选择一个字符
    const randomChar = characters.charAt(Math.floor(Math.random() * characters.length));
    // 随机决定是否转换为大写
    if (Math.random() > 0.5) {
      randomString += randomChar.toUpperCase();
    } else {
      randomString += randomChar;
    }
  }
  return randomString;
}

//转换时间
const formatDateNewTj = (time, pattern) => {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm),
        '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

//按照时间排序
const sortedItems = () => {
  return [...this.items].sort((a, b) => {
    const dateA = new Date(a.time);
    const dateB = new Date(b.time);
    return dateB - dateA;
  });
}

const downloadCf = () => {
  getVersionNumber().then(msg => {
    const str = msg
    const versionRegex = /version:\s*(\S+)/;
    const match = str.match(versionRegex);
    let version = match ? match[1] : null;
    if (version) {
      const downloadCf = `https://cf-chat.com/download/ChatFusion-win-AutoSetup-${version}.exe`
      window.open(downloadCf, "_blank");
    } else {
      message.error('获取版本号失败！')
    }
  });
}

/**
 * 导出
 **/
export {
  getGurrentTime,
  checkEmpty,
  generateRandomString,
  formatDateNewTj,
  getGurrentTimeNothmf,
  timeFormatSeconds,
  downloadCf
}



// WEBPACK FOOTER //
// ./src/utils/common.js